import difference from 'lodash/difference';
import intersection from 'lodash/intersection';

import {
  QuestionEvaluationEnum,
  QuizField,
} from '@/modules/corporate/modules/questions/fields/types';
import { PerformanceEvaluationStatusEnum } from '@/types/schema';

export const getQuestionEvaluation: QuizField['getQuestionEvaluation'] = (performance) => {
  if (performance.evaluationStatus === PerformanceEvaluationStatusEnum.Correct) {
    return { evaluation: QuestionEvaluationEnum.Correct };
  }

  const selectedOptionIds =
    performance.submission?.optionResponse?.map(({ optionId }) => optionId) || [];
  const correctOptionIds = performance.correctOptions.map(({ optionId }) => optionId);
  const missedOptionsCount = difference(correctOptionIds, selectedOptionIds).length;
  const hasAnyCorrectSelected = intersection(selectedOptionIds, correctOptionIds).length;

  if (hasAnyCorrectSelected && missedOptionsCount) {
    return {
      evaluation: QuestionEvaluationEnum.PartiallyCorrect,
      count: missedOptionsCount,
    };
  }

  return { evaluation: QuestionEvaluationEnum.InCorrect };
};
